module.exports = __webpack_public_path__ + "media/images/pages/fcr-case/case-6-3499873386b7cd50945591c7ee824fda.png";